import React from 'react'
import PropTypes from 'prop-types'

import cn from 'classnames'

import './index.scss'

const Pagination = props => {
  const totalPages = Math.ceil(props.resultsCount / props.perPage)

  const getPages = () => {
    let pages = []

    if(totalPages <= 5){
      for (var i=1; i<=totalPages; i++){
        pages.push(i)
      }
    } else if(props.page < 3){
      for (var i=1; i<=5; i++){
        pages.push(i)
      }
    } else if(props.page > totalPages - 2){
      for (var i=totalPages-5; i<=totalPages; i++){
        pages.push(i)
      }
    } else {
      for (var i=props.page-2; i<=props.page+2; i++){
        pages.push(i)
      }
    }

    return(pages)
  }

  const updatePage = page => {
    if(page >= 1 && page <= totalPages && page !== props.page){
      props.updatePage(page)
    }
  }

  return (
    <div className="pagination-wrapper">
      {getPages().length > 1 && <React.Fragment>
        <div className={cn('prev trigger', {active: props.page > 1})} onClick={ () => updatePage(props.page - 1) }>&lt;&lt;</div>
        {getPages().map( page => <div key={page} className={cn('trigger', {current: page === props.page})} onClick={ () => updatePage(page) }>{page}</div>)}
        <div className={cn('next trigger', {active: props.page < totalPages})} onClick={ () => updatePage(props.page + 1) }>&gt;&gt;</div>
      </React.Fragment>}
    </div>
  )
}

Pagination.propTypes = {
  page: PropTypes.number,
  perPage: PropTypes.number,
  resultsCount: PropTypes.number,
  updatePage: PropTypes.func.isRequired,
}

Pagination.defaultProps = {
  page: 1,
  perPage: 10,
  resultsCount: 0,
}

export default Pagination
